import { messages } from './messages';
import { usePlanFeatureGate } from './use-plan-feature-gate';
import { Features } from '../constants/features';

/**
 * @typedef {import('../prop-types/intl-types').MessageDescriptor} MessageDescriptor
 */

/**
 * Custom hook to check if AddOns feature is available.
 * @returns {{
 *   isUnlimitedAutomationRulesEnabled: boolean,
 *   isLimitedAutomationRulesEnabled: boolean,
 *   limitedAutomationRulesAccessBannerDescription: MessageDescriptor,
 *   limitedAutomationRulesAccessBannerTitle: MessageDescriptor
 *}}
 */
export const useAutomationRulesFeatureGate = () => {
  const { isFeatureEnabled: isUnlimitedAutomationRulesEnabled } = usePlanFeatureGate(Features.UnlimitedAutomationRules);
  const { isFeatureEnabled: isLimitedAutomationRulesEnabled } = usePlanFeatureGate(Features.CommonAutomationRules);

  return {
    isUnlimitedAutomationRulesEnabled,
    isLimitedAutomationRulesEnabled,
    limitedAutomationRulesAccessBannerDescription: messages.automationRulesLimitedAccessDescription,
    limitedAutomationRulesAccessBannerTitle: messages.automationRulesLimitedAccessTitle,
  };
};
